// JavaScript Document
//components/configuration/ConfigStandard.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
//import Box from '@material-ui/core/Box';
//import Card from '@material-ui/core/Card';
//import CardActions from '@material-ui/core/CardActions';
//import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
//import Grid from '@material-ui/core/Grid';
import Display from '../../display/Display';
import Sequence from '../../display/Sequence';
import DigitSequence from '../../display/DigitSequence';
import Digits from '../../display/Digits';
import bsModes from '../Modes';
import displayVariant from '../displayVariant';
//const baseModes = bsModes();

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
	pos: {
		marginBottom:12,
	},
	udisplay: {
		backgroundColor: 'black',
		padding: 5,
		color: '#f80',
		height: 55,
		boxSizing:'border-box',
		width : 70
	},
	mode: {
		pading: theme.spacing(2),
		textAlign: 'center',
		width: 70,
		display: 'inline-block',
		margin:2,
	},
	ldisplay : {
		backgroundColor: 'black',
		padding: 2,
		color : '#f80',
		height : 65
	},
}));



export default function DisplayMode(props) {
	const classes = useStyles();
  	const {config, settings, sign} = props;
  	const [speed, setSpeed] = React.useState(25);
  	const [threshold, setThreshold] = React.useState(25);
  	const [maxspeed, setMaxspeed] = React.useState(45);
  	const [max2, setMax2] = React.useState(99);
  	const [op, setOp] = React.useState(0);
  	const [display, setDisplay] = React.useState([0, 0, 0, 0]);
  	const [digits, setDigits] = React.useState(['', '', '', ''])
  	//const [vspeed, setVspeed] = React.useState(0);
  	//const [flashes, setFlashes] = React.useState(0);
	const [loaded, setLoaded] = React.useState(false);
	const baseModes = bsModes(config.custom_modes);
	//display variant compiler
	const dv = displayVariant(sign);
	//matrix digits
	const matrixDigits = [
		//0
		'001111111100,011111111110,011000000110,011000000110,011000000110,011000000110,011000000110,011000000110,011000000110,010000000010,011000000110,011000000110,011000000110,011000000110,011000000110,011000000110,011111111110,001111111100',
		//1
		'000001100000,000011100000,000111100000,001111100000,001101100000,001001100000,000001100000,000001100000,000001100000,000001100000,000001100000,000001100000,000001100000,000001100000,000001100000,000001100000,001111111100,001111111100',
		//2
		'000011111000,001111111100,011100001110,001000000110,000000000110,000000000110,000000001100,000000011100,000000011000,000001110000,000011100000,000111000000,001100000000,001100000000,011000000000,011000000000,011111111110,011111111110',
		//3
		'001111111100,001111111110,000000000110,000000000110,000000000110,000000000110,000000000110,000000000110,001111111110,001111111110,000000000110,000000000110,000000000110,000000000110,000000000110,000000000110,001111111110,001111111100',
		//4
		'000000001100,000000011100,000000111100,000001111100,000011101100,000111001100,001110001100,011100001100,011111111110,011111111110,000000001100,000000001100,000000001100,000000001100,000000001100,000000001100,000000001100,000000001100',
		//5
		'011111111100,011111111100,011000000000,011000000000,011000000000,011000000000,011000000000,011011110000,011111111100,001100001100,000000000110,000000000110,000000000110,000000000110,000000001100,000000011100,011111111000,011111110000',
		//6
		'000111111100,001111111000,011100000000,011000000000,011000000000,011000000000,011000000000,011000000000,011111111000,011111111100,011100001110,011000000110,011000000110,011000000110,011000000110,011100001110,001111111100,000111111000',
		//7
		'011111111110,011111111110,000000000110,000000001110,000000011100,000000111000,000001110000,000011100000,000011000000,000011000000,000011000000,000011000000,000011000000,000011000000,000011000000,000011000000,000011000000,000011000000',
		//8
		'000111111000,001111111100,011100001110,011000000110,011000000110,011000000110,011000000110,001100001100,000111111000,001111111100,011100001110,011000000110,011000000110,011000000110,011000000110,011100001110,001111111100,000111111000',
		//9
		'000111111000,001111111100,011000000110,011000000110,011000000110,011000000110,011000000110,011100000110,001111111110,000111111110,000000000110,000000000110,000000000110,000000000110,000000000110,011000001110,001111111100,000111111000'
	]
	
	//preset displays
	const d_xxmph = "000000000000000000000000000000,000000000000000000000000000000,000000000000000000000000000000,000000000000000000000000000000,000000000000000000000000000000,000000000000000000000000000000,000000000000000000000000000000,000000000000000000000000000000,000000000000000000000000000000,100010011100000000000000100000,100010100010000000000000100000,100010100000110100101100101100,010100011000101010110010110010,010100000100101010100010100010,010100000010101010100010100010,001000100010101010110010100010,001000100010101010101100100010,001000011100100010100000100010";
	const d_vs = "000000110000000011000111111100,000000110000000011001111111110,000000110000000011011100000111,000000011000000110011000000011,000000011000000110011000000011,000000011000000110011000000000,000000001100001100011100000000,000000001100001100001111111000,000000001100001100000111111100,000000000110011000000000001110,000000000110011000000000000111,000000000110011000000000000011,000000000011110000000000000011,000000000011110000011000000011,000000000011110000011100000111,000000000001100000001110001110,000000000001100000000111111100,000000000001100000000011111000";
	
  	//const [editView, setEditView] = React.useState(false);
  	
  	const getDisplay = (mode) => {
		var out = [];
		var modeprops = baseModes.find(m => m.id === mode);
		for(var n in modeprops.message){
		
		  	switch(modeprops.message[n]){
				case 1:
			  		out.push(config.messages[0]);
					break;
				case 2:
					out.push(config.messages[1]);
					break;
				case 3:
					out.push(config.messages[2]);
					break;
				case 4:
					out.push(config.messages[3]);
					break;
				case 5:
					out.push('xxmph');
					break;
				case 6: //1-4 normal
					out.push({
						maps: [
							config.pixel_maps[config.messages[0]],
							config.pixel_maps[config.messages[1]],
							config.pixel_maps[config.messages[2]],
							config.pixel_maps[config.messages[3]]
						]
					});
					break;
				case 7: //1-4 
					out.push({
						maps: [
							displayPush(config.pixel_maps[config.messages[0]]),
							displayPush(config.pixel_maps[config.messages[1]]),
							displayPush(config.pixel_maps[config.messages[2]]),
							displayPush(config.pixel_maps[config.messages[3]])
						]
					});
					break;
				case 8: //1-2
					out.push({
						maps: [
							config.pixel_maps[config.messages[0]],
							config.pixel_maps[config.messages[1]]
						]
					});
					break;
				case 9: //1-3
					out.push({
						maps: [
							config.pixel_maps[config.messages[0]],
							config.pixel_maps[config.messages[2]]
						]
					});
					break;
				case 10: //1-4
					out.push({
						maps: [
							config.pixel_maps[config.messages[0]],
							config.pixel_maps[config.messages[3]]
						]
					});
					break;
				case 11: //2-3
					out.push({
						maps: [
							config.pixel_maps[config.messages[1]],
							config.pixel_maps[config.messages[2]]
						]
					});
					break;
				case 12: //2-4
					out.push({
						maps: [
							config.pixel_maps[config.messages[1]],
							config.pixel_maps[config.messages[3]]
						]
					});
					break;
				case 13: //3-4
					out.push({
						maps: [
							config.pixel_maps[config.messages[2]],
							config.pixel_maps[config.messages[3]]
						]
					});
					break;
				default:
					out.push(0);
				  
			}
		//  }
		  
	  	}
		return out;
  	}
	const getDigits = (mode) => {
		var out = [];
		var modeprops = baseModes.find(m => m.id === mode);
		for(var n in modeprops.speed){
			if(modeprops.flash[n] === 1 //&& flashes%2 === 1
			){
				out.push('');
			} else {
				switch(modeprops.speed[n]){
					case 1:
						out.push(speed)
						break;
					case 2:
						/*
						if(n === 0 && vspeed > 0 && vspeed <= Math.min(threshold, maxspeed, max2)){
							out.push(vspeed);
						} else if(n === 1 && vspeed > threshold && vspeed <= Math.min(maxspeed, max2)){
							out.push(vspeed);
						} else if(n === 2 && vspeed > maxspeed && vspeed <= max2){
							out.push(vspeed);
						} else if(n === 3 && vspeed > max2){
							out.push(vspeed);
						} else {
							*/
							out.push('VS');
						//}
						break;
						//out.push(vspeed[n]);
					case 3: //alternate VS & SL
						out.push('SLVS');
						break;
					case 4: //alternate upper display & SL
						out.push('UDSL');
						break;
					case 5: //alternate upper display & VS
						out.push('UDVS');
						break;
					default:
						out.push('');
				}
			}
		}
		return out;
	}
	/*
	//Get the size
	const getSize = () => {

		return {
			width: dv.width,
			height: dv.height,
			splitVertical: dv.split
		}
	}
	*/
	
	//Compile the map doing any necessary conversions
	const compileMap = (pmap) => {

		return dv.extract(pmap);
	}
	
	//Push the display down by 9
	const displayPush = (disp) => {
		var pmap = Array(9).fill('0'.repeat(30)).join(',')+disp.pixel_map.split(',').slice(0, 9).join(',');
		return {
			id: disp.id,
			pixel_map: pmap
		}
	}
	
	//compile sequence from object
	const compileSequence = (disp) => {
		//var size = getSize();
		//var pmaps = disp.maps.map(compileMap);
		return (
			<Sequence
				ids={disp.maps.map(e => e.id)}
				width={dv.size.width}
				height={dv.size.height}
				splitVertical={dv.size.split}
				scale={2}
				pixel_maps={disp.maps.map(e => dv.extract(e.pixel_map))}
				borderSize="5"
				timing={{on: config.flashOnTime, off:config.flashOffTime, period:config.flashPeriod}}
			/>
		)
	}
	
	//compile matrix digits from Number
	const compileMatrixDigits = (num) => {
		if(num === 0)
			return Array(18).fill('0'.repeat(30)).join(',');
		//start with 18 lines of 6 0s
		var pmap = Array(18).fill('0'.repeat(6)).join(',');
		if(num > 9){
			pmap = addDigit(pmap, matrixDigits[Math.floor(num / 10)]);
		} else {
			pmap = addDigit(pmap, Array(18).fill('0'.repeat(12)).join(','));
		}
		return addDigit(pmap, matrixDigits[num%10]);
	}
	
	//add digit to map ie append all lines of string to string
	const addDigit = (pmap, digit) => {
		//digit = digit.split(',');
		return pmap.split(',').map((l, i) => l+digit.split(',')[i]).join(',');
	}
	
	//Render the upper display
	const compileDisplay = (num) => {
		var msgid = display[num];
		var size = dv.size;
		if(dv.size.width === 0 && dv.size.height === 0) return '';
		var pmap = '';
		if(typeof msgid === 'object'){
			//check for funky stuff with matrixDigits
			if(sign.sign_type_obj){
				if(sign.sign_type_obj.cfg_reference === 'matrixDigits4'){
					if(digits[num] === 'UDSL'){
						//upper display & speed limit alternate
						//speed limit message (1) with posted speed limit
						return compileSequence({
							maps: [
								config.pixel_maps[config.messages[0]],
								{
									id: msgid+250,
									pixel_map: compileMatrixDigits(speed)
							
							}]
						})
					} else if(digits[num] === 'UDVS'){
						//upper display & vehicle speed
						//slow down message(3) with vehicle speed
						return compileSequence({
							maps: [
								config.pixel_maps[config.messages[2]],
								{	
									id: msgid+500,
									pixel_map: d_vs
								}
							]
						});
					}
				}
			}
			return compileSequence(msgid);
		}
		if(msgid === 'xxmpg'){
			pmap = d_xxmph;
		} else if(msgid === 0 || msgid === '0' || config.pixel_maps[msgid] === undefined) {
			pmap = Array(18).fill('0'.repeat(30)).join(',');
	
		} else {
			pmap = config.pixel_maps[msgid].pixel_map;
		}
		if(sign.sign_type_obj){
			if(sign.sign_type_obj.cfg_reference === 'matrixDigits4'){
				if(digits[num] === 'VS'){
					pmap = d_vs;
				} else if(digits[num] === 'UDSL'){
					//upper display & speed limit alternate
					return compileSequence({
						maps: [{
							id: msgid,
							pixel_map: pmap
						}, {
							id: msgid+250,
							pixel_map: compileMatrixDigits(speed)
						
						}]
					})
				} else if(digits[num] === 'UDVS'){
					//upper display & vehicle speed
					return compileSequence({
						maps: [
							{
								id: msgid,
								pixel_map: pmap
							},
							{	
								id: msgid+500,
								pixel_map: d_vs
							}
						]
					});
				}
			}
		}
		// = compileMap(pmap);
		
		return (
			<Display 
				id={msgid} 
				scale={2} 
				splitVertical={size.split} 
				width={size.width} 
				height={size.height} 
				pixel_map={compileMap(pmap)}
				borderSize="5"
			/>
		);   
	}
	
	//Render digits
	const renderDigits = (num) => {
		var dnum = digits[num];
		if(sign.sign_type_obj){
			if(sign.sign_type_obj.class_width){
				if(sign.sign_type_obj.opt_digits === 0)
					return '';
			}
		}
		if(dnum === 'SLVS')
			return (
				<DigitSequence timing={{on: config.flashOnTime, off: config.flashOffTime, period: config.flashPeriod}} sequence={[speed, 'VS']} />
			)
		if(dnum === 'UDSL')
			dnum = speed;
		if(dnum === 'UDVS')
			dnum = 'VS';
		return (
			<Digits key={2} text={dnum} />
		);
	}
	

	React.useEffect(() => {
		setOp(settings.op);
		setSpeed(settings.speed);
		setThreshold(settings.threshold);
		setMaxspeed(settings.maxspeed);
		setMax2(config.maxTwoDisplaySpeed);
		setDisplay(getDisplay(op));
		setDigits(getDigits(op));
		if(!loaded){
			setTimeout(() => setLoaded(true), 50);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props, loaded]);
	
  return (
    <div className={classes.root}>
	  		<Paper className={classes.mode}>
	  			{compileDisplay(0)}
	  			{renderDigits(0)}
	  			<Typography variant="h6">
	  				0-{threshold}
	  			</Typography>
	  		</Paper>
	  		<Paper className={classes.mode}>
				{compileDisplay(1)}
	  			{renderDigits(1)}
	  			<Typography variant="h6">
	  				{threshold > maxspeed || threshold > max2 ? 'x' : (parseInt(threshold)+1)+'-'+Math.min(maxspeed, max2)}
				</Typography>
			</Paper>
			<Paper className={classes.mode}>
				{compileDisplay(2)}
				{renderDigits(2)}
				<Typography variant="h6">
					{threshold > max2 || maxspeed > max2 ? 'x':(parseInt(maxspeed)+1)+'-'+max2}
				</Typography>
			</Paper>
			<Paper className={classes.mode}>
				{compileDisplay(3)}
				{renderDigits(3)}
				<Typography variant="h6">
					{'>'+max2}
				</Typography>
			</Paper>
	  	
    </div>
  );
}
